import Swal from "sweetalert2";
import { GETALLFRANCHISE, INTRESTEDFORFRANCHISE } from "../../utils/api";
import axios from "../../utils/axios";
import { swalAlertPopProps } from "../../utils/commonUtils";


export const getAllfranchise = async (payload, callback) => {
  await axios
    .post(GETALLFRANCHISE, payload)
    .then((res) => {
      callback(res);
    })
    .catch((err) => {
      console.error("Error fetching employee attendance:", err);
    });
};

export const intrestedApply = async (payload, callback) => {
  await axios
    .post(INTRESTEDFORFRANCHISE, payload)
    .then((res) => {
      callback?.(res);
      if (res?.data?.succeeded) {
        Swal.fire({
          text: "Thank you for applying",
          icon: "success",
          ...swalAlertPopProps,
        });
      } else {
        Swal.fire({
          text: res?.data?.message,
          icon: "error",
          ...swalAlertPopProps,
        });
      }
      return res;
    })
    .catch((err) => {
      Swal.fire({
        text: err?.response?.data?.message || "Something went wrong",
        icon: "error",
        ...swalAlertPopProps,
      });
      throw err;
    });
};